import { HostBinding, Component, OnInit, Injector, ElementRef, ViewContainerRef, ViewChild } from '@angular/core';
import { EventsComponent } from '../events/events.component';
import * as moment from 'moment';
import * as bowser from 'bowser';
import { DatePickerComponent, IDatePickerConfig } from 'ng2-date-picker';
import { get, includes } from 'lodash';
const DATE_FORMAT = 'MM/DD/YYYY';

@Component({
	selector: 'Datepicker',
	template: `
		<div class="datepicker" [ngClass]="{ disabled: control.disabled, error: error }">
			<div class="input-container">
				<form #maskedInputForm [ngClass]="{ error: error, disabled: control.disabled }" class="datepicker-form">
					<input
						class="masked-datepicker"
						[attr.id]="control.name.split('PolicyData.').join('')"
						[attr.aria-describedby]="control.name.split('.').join('_') + '_error'"
						[ngClass]="{ textcolor: inputValue && inputValue.length > 0 }"
						name="maskedInput"
						type="tel"
						[value]="value"
						(blur)="updateMaskedDate($event)"
						[textMask]="{ mask: getmask() }"
						placeholder="MM/DD/YYYY"
						[disabled]="control.disabled"
						autocomplete="off"
						(keydown)="onKeyDownEvent($event)"
						(keyup.enter)="keypadClose()"
						[attr.gtm]="gaLabel"
					/>
				</form>
				<dp-date-picker
					[(ngModel)]="inputValue"
					[disabled]="control.disabled"
					[config]="datePickerConfig"
					(close)="updateDate()"
					placeholder="MM/DD/YYYY"
					#dayPicker
				>
				</dp-date-picker>

				<i
					tabindex="0"
					role="button"
					aria-label="Calendar"
					[attr.aria-expanded]="isOpen"
					class="icon icon-calendar2"
					(keydown)="openCalendarWithKey($event)"
					(click)="toggle()"
				></i>
			</div>
		</div>
	`,
	styleUrls: ['./datepicker.component.scss'],
})
export class DatepickerComponent extends EventsComponent implements OnInit {
	@ViewChild('maskedInputForm', { static: true })
	maskedInputForm;

	inputValue: any;
	currentDate: any;
	allowedChars: any;
	inactiveMinDate: any;
	inactiveMaxDate: any;
	isOpen = false;
	isOpenDatepicker: boolean;
	isFirstLoad = true;
	mask: any;
	minDate: any;
	maxDate: any;
	config = {
		format: 'MM/DD/YYYY',
		closeOnSelect: true,
		onOpenDelay: 6000,
		openOnClick: true,
	};
	maskOptions: any;
	@HostBinding('attr.name')
	name = this.control ? this.control.name : '';
	datePickerConfig: IDatePickerConfig;
	@ViewChild('dayPicker', { static: true })
	datePicker: DatePickerComponent;

	constructor(injector: Injector, private el: ElementRef) {
		super(injector);
		this.el = el;
	}

	ngOnInit() {
		this.gaLabel = this.getGaLabel(this.control);
		if (this.value) {
			this.reportPrefill();
		}
		this.allowedChars = [48, 49, 50, 51, 52, 53, 54, 55, 56, 57];
		this.inactiveMinDate = this.parseDate(get(this.control.attributes, 'inactiveDates.minDate'));
		this.inactiveMaxDate = this.parseDate(get(this.control.attributes, 'inactiveDates.maxDate'));
		this.inputValue = this.value;
		this.isFirstLoad = true;
		this.isMobile =
			bowser.getParser(window.navigator.userAgent).getPlatformType() === 'mobile' ||
			bowser.getParser(window.navigator.userAgent).getPlatformType() === 'tablet';
		this.maskOptions = {
			// maskDefinitions: { '9': /[X0-9]/, 'A': /[a-zA-Z]/, '*': /[a-zA-Z0-9]/ },
			allowInvalidValue: true,
			clearOnBlur: false,
			eventsToHandle: ['input', 'keyup', null, 'focus'],
		};

		this.datePickerConfig = {
			format: 'MM/DD/YYYY',
			weekDayFormat: 'dd',
			openOnClick: false,
			openOnFocus: false,
			enableMonthSelector: false,
			min: this.parseDate(this.control.attributes.minDate),
			max: this.parseDate(this.control.attributes.maxDate),
		};
		const elem = this.elementRef.nativeElement.querySelectorAll('input')[1];
		this.Renderer.setAttribute(elem, 'id', this.control.name.split('.').join('_') + '2');
		this.Renderer.setAttribute(elem, 'maxlength', '10');
		// [textMask]="{mask: getmask(control.attributes.inputMask, maskArr)}"

		this.Renderer.listen(elem, 'blur', (e) => {
			this.updateDate();
		});

		this.Renderer.listen(elem, 'keypress', (e) => {
			this.validateValue(e);
		});
	}

	validateValue(e) {
		if (!includes(this.allowedChars, e.keyCode)) {
			event.preventDefault();
		}
	}

	closePicker() {
		this.isOpen = false;
	}
	getmask() {
		return [/[0-9]/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
	}
	parseDate(date) {
		if (!date) {
			return;
		}

		// Check if the date string starts from - or + signs (-2d, +3M)
		if (includes(['-', '+'], date.slice(0, 1))) {
			return this.stringToDate(date);
		}

		return moment(date, DATE_FORMAT);
	}

	initialDate() {
		if (moment(this.inputValue, DATE_FORMAT).isValid()) {
			this.currentDate = moment(this.inputValue, DATE_FORMAT).toDate();

			return this.currentDate;
		}
	}

	isDateDisabled({ date }) {
		return moment(date).isBetween(this.inactiveMinDate, this.inactiveMaxDate, null, '[]');
	}

	toggle() {
		if (!this.control.disabled) {
			this.isOpen = !this.isOpen;

			if (this.isOpen) {
				this.datePicker.api.open();
			} else {
				this.datePicker.api.close();
			}
			const dpElem = this.elementRef.nativeElement.querySelector('dp-date-picker');
			this.Renderer.setStyle(dpElem, 'position', '');
		}
	}

	updateMaskedDate(event) {
		this.inputValue = event.target.value;
		this.updateDate();
	}

	updateDate() {
		//  if(!this.isFirstLoad) {
		//   this.isOpen = !this.isOpen;
		//   return;
		//  }
		this.isFirstLoad = false;
		this.isOpen = false;
		if (moment(this.inputValue, DATE_FORMAT).isValid()) {
			this.currentDate = moment(this.inputValue, DATE_FORMAT).toDate();
			if (typeof this.inputValue.format == 'function') {
				this.value = this.inputValue.format('MM/DD/YYYY');
			} else {
				this.value = this.inputValue;
			}

			return this.setAnswer(this.value);
		} else {
			this.inputValue = false;
			return this.setAnswer(null);
		}
	}

	stringToDate(str) {
		const sign = str.substring(0, 1);
		const num = str.substring(1, str.length - 1);
		const key = str.substring(str.length - 1, str.length);

		switch (sign) {
			case '-':
				return moment().startOf('day').startOf('day').subtract(num, key);

			case '+':
				return moment().startOf('day').endOf('day').add(num, key);
		}
	}

	close() {
		this.isOpen = false;
	}

	getInputClass() {
		return {
			'datepicker-input': true,
			active: this.isOpenDatepicker,
			textcolor: this.value != undefined && this.value.length > 0,
		};
	}

	openCalendarWithKey(event) {
		if (event.keyCode === 13 || event.keyCode === 32) {
			this.toggle();
		}
	}

	onKeyDownEvent(event) {
		// detect Ctrl+z key combination and (if detected) clear the input field
		if (event.keyCode === 90 && event.ctrlKey === true) {
			this.elementRef.nativeElement.querySelector('.masked-datepicker').value = '';
		}
	}

	keypadClose() {
		this.isMobile && this.el.nativeElement.querySelector('.masked-datepicker').blur();
	}
}
